import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import home from '@/view/home'
import aboutUs from '@/view/aboutUs'
import concat from '@/view/concat'
import mediaCenter from '@/view/mediaCenter'
import notices from '@/view/notices'
import product from '@/view/product'
import cases from '@/view/case'
import services from '@/view/services'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      redirect: '/home',
      children: [{
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/about',
          name: 'about',
          component: aboutUs,
        },
       
        // 联系我们
        {
          path: '/concat',
          name: 'concat',
          component: concat,
        },
        //媒体中心
        {
          path: '/mediaCenter',
          name: 'mediaCenter',
          component: mediaCenter,
        },
        // 公司通告
        {
          path: '/notices',
          name: 'notices',
          component: notices,
        },
        
        //产品
        {
          path: '/product',
          name: 'product',
          component: product,
        },
        //服务
        {
          path: '/services',
          name: 'services',
          component: services,
        },
        //案例
        {
          path: '/cases',
          name: 'cases',
          component: cases,
        },
        
        
      ]
    },
    {
      path: '*',
      redirect: '/notfound'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(to)
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: {
          y: 90
        }
      }
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },

})
router.beforeEach((to, from, next) => {
  let path = to.path
  let len = path.length
  if (path.lastIndexOf('/') == len - 1) {
    path = path.substring(0, len - 1)
    next({
      path: path
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js